import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    copyBtn: {
      padding: "0px 0px 0px 5px"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    subSection: {
      display: "flex",
      flexDirection: "column",
      marginTop: "9px"
    },
    subSectionTitle: {
      flex: 1,
      fontWeight: 500,
      lineHeight: 1,
      marginTop: "0px"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 800,
      whiteSpace: "nowrap"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "right",
      whiteSpace: "nowrap"
    },
    textRightBlue: {
      color: "#247CFF",
      fontSize: "14px",
      textAlign: "right",
      whiteSpace: "nowrap"
    },
    title: {
      flex: 1,
      fontWeight: 800,
      lineHeight: 1
    }
  }),
  { name: "RemittanceRunnerRemitter" }
);

export interface RemittanceRunnerRemitterProps {
  remitterName: string;
  remitterEmail: string;
  remitterContactNum: string;
}

const RemittanceRunnerRemitter: React.FC<RemittanceRunnerRemitterProps> = props => {
  const { remitterName, remitterEmail, remitterContactNum } = props;
  const classes = useStyles(props);

  return (
    <Card>
      <CardTitle title="Remitter" />
      <CardContent>
        <table className={classes.root}>
          <tbody>
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Name"
                  description="Remitter name"
                />
              </td>
              <td className={classes.textRight}>{remitterName}</td>
            </tr>
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Email Address"
                  description="Remitter email"
                />
              </td>
              <td className={classes.textRightBlue}>{remitterEmail}</td>
            </tr>
            <tr>
              <td className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Contact Number"
                  description="Remitter contact number"
                />
              </td>
              <td className={classes.textRightBlue}>{remitterContactNum}</td>
            </tr>
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
RemittanceRunnerRemitter.displayName = "RemittanceRunnerRemitter";
export default RemittanceRunnerRemitter;
